import { motion } from "framer-motion";
import { MaskLines, introDelay } from "./Motion";

export const PageHeader = ({ eyebrow, lines, text, testid }) => {
  const d = introDelay();
  return (
    <header data-testid={testid} className="relative mx-auto max-w-7xl px-5 sm:px-8 pt-36 sm:pt-44 pb-12">
      <div aria-hidden="true" className="pointer-events-none absolute -top-40 right-0 w-[60vw] h-[60vw] max-w-[700px] max-h-[700px] rounded-full bg-[radial-gradient(circle,rgba(255,85,0,0.22),transparent_65%)] blur-2xl" />
      <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: d }} className="eyebrow relative">{eyebrow}</motion.p>
      <h1 className="relative mt-5 font-display uppercase leading-[0.86] tracking-[-0.045em] text-[12vw] sm:text-8xl lg:text-[8.5rem]">
        <MaskLines delay={d} lines={lines} />
      </h1>
      {text && (
        <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: d + 0.4, duration: 0.8 }} className="relative mt-8 max-w-lg text-zinc-300 sm:text-lg">
          {text}
        </motion.p>
      )}
    </header>
  );
};
